import React, { PropTypes } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import partial from 'lodash/partial';
import Avatar from 'common/components/avatar';

const RevisionComments = ({ comments, hoveredCommentId, setHoveredComment }) => {
  return (
    <div className="results-comments">
      { comments.map(({ id, author, body, created_at, percent_x }) => {
        const inPlace = !!percent_x;
        const classes = classnames('presentation-comment', {
          hovered: hoveredCommentId === id,
          dimmed: hoveredCommentId && hoveredCommentId !== id
        });
        let inPlaceIdx = 1;
        if (inPlace) {
          inPlaceIdx = comments.filter(c => !!c.percent_x).findIndex(c => c.id === id) + 1;
        }

        return (
          <div key={id} className={classes}
            onMouseEnter={inPlace? partial(setHoveredComment, id) : undefined}
            onMouseLeave={inPlace? partial(setHoveredComment, null): undefined}>
            <div className="row">
              <div className="columns small-16">
                <div className="comment-date">{ moment(created_at).fromNow() }</div>
              </div>
              <div className="columns small-4 medium-3">
                <Avatar user={{ username: author.name }}
                  extraClasses="avatar-md avatar-round avatar-shadow avatar-inline" />
              </div>
              <div className="columns small-12 medium-13 large-10">
                <div className="comment-wrapper">
                  <div className="comment-name">{ author.name }</div>
                  <div>{ body }</div>
                  { inPlace &&
                  <div className="badge badge-primary badge-md comment-pin">{ inPlaceIdx }</div> }
                </div>
              </div>
            </div>
          </div>
        );
      }) }
    </div>
  );
}

RevisionComments.propTypes = {
  setHoveredComment: PropTypes.func.isRequired,
  hoveredCommentId: PropTypes.number,
  comments: PropTypes.array.isRequired,
};

export default RevisionComments;



// WEBPACK FOOTER //
// ./presentations/components/revision_comments.jsx